import React from 'react';
import PropTypes from 'prop-types';

import withGooglePlaces from 'dpl/decorators/withGooglePlaces';
import MobileLocationResultsList from 'dpl/search/components/MobileLocationResultsList';
import MobileLocationResultsListV2 from 'dpl/search/components/MobileLocationResultsListV2';

function MobileLocationResultsListContainer(props) {
  const { isNewLayout } = props;

  if (isNewLayout) {
    return <MobileLocationResultsListV2 {...props} />;
  }

  return <MobileLocationResultsList {...props} />;
}

MobileLocationResultsListContainer.propTypes = {
  isNewLayout: PropTypes.bool
};

MobileLocationResultsListContainer.defaultProps = {
  isNewLayout: false
};

export default withGooglePlaces(MobileLocationResultsListContainer);
